import React from "react";

const ALLOWED_TAGS = new Set([
  "A",
  "B",
  "BR",
  "EM",
  "I",
  "LI",
  "OL",
  "P",
  "S",
  "SPAN",
  "STRONG",
  "U",
  "UL",
]);
const BLOCKED_TAGS = new Set([
  "EMBED",
  "IFRAME",
  "MATH",
  "OBJECT",
  "SCRIPT",
  "STYLE",
  "SVG",
]);

const safeHref = value => {
  try {
    const url = new URL(value, window.location.origin);
    return ["http:", "https:", "mailto:"].includes(url.protocol)
      ? url.toString()
      : null;
  } catch {
    return null;
  }
};

const childNodes = node => Array.from(node.childNodes || []);

const renderNode = (node, key) => {
  if (node.nodeType === Node.TEXT_NODE) return node.textContent;
  if (node.nodeType !== Node.ELEMENT_NODE) return null;

  const children = childNodes(node).map((child, index) =>
    renderNode(child, `${key}-${index}`)
  );
  const tag = node.tagName.toUpperCase();
  if (BLOCKED_TAGS.has(tag)) return null;
  if (!ALLOWED_TAGS.has(tag)) {
    return <React.Fragment key={key}>{children}</React.Fragment>;
  }
  if (tag === "P") {
    return <React.Fragment key={key}>{children}</React.Fragment>;
  }
  if (tag === "BR") return <br key={key} />;

  const props = { key };
  if (tag === "A") {
    const href = safeHref(node.getAttribute("href"));
    if (!href) return <React.Fragment key={key}>{children}</React.Fragment>;
    props.href = href;
    props.rel = "noopener noreferrer";
  }
  return React.createElement(tag.toLowerCase(), props, children);
};

const parse = value => {
  const documentValue = new DOMParser().parseFromString(
    `<body>${String(value || "")}</body>`,
    "text/html"
  );
  return childNodes(documentValue.body).map((node, index) =>
    renderNode(node, `rich-${index}`)
  );
};

export const richTextPlainText = value => {
  if (!value) return "";
  const documentValue = new DOMParser().parseFromString(
    `<body>${String(value)}</body>`,
    "text/html"
  );
  return documentValue.body.textContent.trim();
};

export const RichTextLabel = ({ value }) => (
  <span className="fera-rich-label">{parse(value)}</span>
);
